var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgRightGrayTrigger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 21,
    viewBox: "0 0 11 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.351799 18.2866C-0.109284 18.7403 -0.118052 19.4848 0.332214 19.9495C0.782481 20.4141 1.52128 20.423 1.98236 19.9692L10.5815 11.5068C11.0426 11.0531 11.0513 10.3086 10.6011 9.8439C10.56 9.80151 10.5165 9.76291 10.471 9.72811C10.42 9.59962 10.3454 9.47811 10.247 9.37013L2.05357 0.380428C1.61762 -0.0978915 0.879443 -0.129502 0.404799 0.309821C-0.0698445 0.749143 -0.101213 1.49304 0.334736 1.97135L8.18179 10.5811L0.351799 18.2866Z",
    fill: "#D4D4D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGrayTrigger);
export default __webpack_public_path__ + "static/media/right_gray_trigger.2f1377ae63b23dc85b7cd24c337456b2.svg";
export { ForwardRef as ReactComponent };